import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalLayout from '../layouts/ModalLayout';
import Button from '../buttons/Button';
import { BankTransactionWithParticipation } from '../../../types/bankAccount';

interface DeleteSplitTransactionWarningModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  transaction: BankTransactionWithParticipation | null;
  onConfirmDeleteAll: () => void;
}

export default function DeleteSplitTransactionWarningModal({
  open,
  setOpen,
  transaction,
  onConfirmDeleteAll,
}: DeleteSplitTransactionWarningModalProps): JSX.Element {
  const { t } = useTranslation('', { keyPrefix: 'page.financial.deleteSplitTransactionWarning' });

  const handleConfirm = () => {
    onConfirmDeleteAll();
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  if (!transaction) return <></>;

  return (
    <ModalLayout
      open={open}
      setOpen={setOpen}
      className="w-full max-w-md rounded-lg"
      closeButton>
      <div className="rounded-md bg-secondary-50 p-6">
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-primary-900 mb-2">
            {t('title')}
          </h3>
          <p className="text-sm text-gray-600 mb-4">
            {t('description')}
          </p>
          <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3 mb-4">
            <p className="text-sm text-yellow-800">
              <strong>{t('transactionDetails')}:</strong>
            </p>
            <p className="text-sm text-yellow-800 mt-1">
              {transaction.description}
            </p>
            <p className="text-sm text-yellow-800">
              {new Date(transaction.date).toLocaleDateString()}
            </p>
          </div>
        </div>
        
        <div className="flex justify-end gap-3">
          <Button
            variant="secondary"
            onClick={handleCancel}
            className="px-4 py-2">
            {t('cancelButton')}
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirm}
            className="px-4 py-2">
            {t('deleteAllButton')}
          </Button>
        </div>
      </div>
    </ModalLayout>
  );
}
